import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import * as atoms from '../atoms';
import type { AgentContext } from '../types';
import useSelectedEnv from './useSelectedEnv';

export const mergeKeepingEnv = (
  prev: AgentContext | undefined,
  next: AgentContext | undefined,
  selectedEnvId: string | undefined,
): AgentContext | undefined => {
  const prevEnvIds = prev?.environmentIds ?? [];
  if (!next) {
    return prevEnvIds.length > 0 ? { environmentIds: prevEnvIds } : undefined;
  }
  if (next.environmentIds && next.environmentIds.length > 0) {
    return next;
  }
  if (prevEnvIds.length === 0) {
    return selectedEnvId ? { ...next, environmentIds: [selectedEnvId] } : next;
  }
  return { ...next, environmentIds: prevEnvIds };
};

const useChatContext = (context: AgentContext | undefined) => {
  const setAiChatPanel = useSetRecoilState(atoms.aiChatPanel);
  const selectedEnvId = useSelectedEnv();

  useEffect(() => {
    setAiChatPanel((prev) => ({
      ...prev,
      context: mergeKeepingEnv(prev.context, context, selectedEnvId),
    }));
    return () =>
      setAiChatPanel((prev) => ({
        ...prev,
        context: mergeKeepingEnv(prev.context, undefined, selectedEnvId),
      }));
  }, [context, setAiChatPanel, selectedEnvId]);
};

export default useChatContext;
